<template>
  <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
    <v-row>
      <v-col cols="12">
        <div class="font-size-12 cl-grey font-weight-500">Weekly Network Growth</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div id="chart-netgrow">
          <template v-if="memberGrowList.length > 0">
            <apexchart type="area" height="350" :options="netGrow.chartOptions" :series="netGrow.series"></apexchart>
          </template>
          <template v-else>
            <div class="d-flex flex-column fill-height align-center justify-center pa-5">
              <v-icon color="grey" large>mdi-information-outline</v-icon>
              <div class="font-size-10 mt-4 text-center cl-grey">No member growth data available.</div>
            </div>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
			apexchart: VueApexCharts
		},
  data() {
    return {
		}
  },
  props: {
    memberGrowList: Array,
    netGrow: Object,
  }
}
</script>